/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface EtlExportDescDTO { 
    id?: string;
    name?: string;
    tenant?: string;
    partner?: string;
    exportPartners?: Array<string>;
    exportMode?: 'GROUPED' | 'SEPARATE';
    affectedPartners?: Array<string>;
    owner?: string;
    code?: string;
    complet?: boolean;
    description?: string;
    view?: string;
}